const SexEnum = Object.freeze({
  'M': 'Masculino',
  'F': 'Feminino',
})

export default SexEnum;
